import React from 'react';
import { Button, makeStyles } from '@fluentui/react-components';
import { themeTokens } from '../utils/Theming';

const useStyles = makeStyles({
  container: {
    position: 'fixed',
    bottom: '20px',
    left: '20px',
    right: '20px',
    display: 'flex',
    justifyContent: 'center',
    zIndex: 2,
    backgroundColor: themeTokens.colorNeutralBackground1,
  },
  button: {
    width: '100%',
    maxWidth: '300px',
  },
});

const BottomFixedButton = ({ buttonText, className = "", ...props }) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Button {...props} className={`${styles.button} ${className}`}>
        {buttonText}
      </Button>
    </div>
  );
};

export default BottomFixedButton;
